import { createContext, useContext } from "react";
import { Preferences } from "@smartsuite/types";
import { FormConfig } from "../types/form";

export interface FormContextValue {
  accountId: string;
  passcode?: string | null;
  config: FormConfig;
  isInternal?: boolean;
  preferences: Preferences;
  reportId?: string;
}

export const FormContext = createContext<FormContextValue | null>(null);

export function useFormContext(): FormContextValue {
  const context = useContext(FormContext);
  if (!context) throw new Error("FormContext must be initialized.");
  return context;
}
